// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const FirstIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "First",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.58 2.48c-.31-.3-.74-.48-1.21-.48-.5 0-.94.21-1.26.54L2.46 14.73v.08l-.11.18c-.07.09-.13.19-.18.29-.03.1-.05.21-.07.32-.03.1-.05.22-.06.33 0 .13.03.24.06.35.01.11.04.22.07.32.06.1.12.2.19.29s.11.17.11.17v.08l11.65 12.19c.32.4.82.66 1.37.66.97 0 1.75-.78 1.75-1.75 0-.52-.23-.99-.59-1.31S6.15 15.98 6.15 15.98l10.5-11.02a1.743 1.743 0 0 0-.06-2.48Zm12.73 0C29 2.18 28.57 2 28.1 2c-.5 0-.94.21-1.26.54L15.19 14.73v.08l-.11.18c-.07.09-.13.19-.18.29-.03.1-.05.21-.07.32-.03.1-.05.22-.06.33 0 .13.03.24.06.35.01.11.04.22.07.32.06.1.12.2.19.29s.11.17.11.17v.08l11.65 12.19c.32.4.82.66 1.37.66.97 0 1.75-.78 1.75-1.75 0-.52-.23-.99-.59-1.31s-10.5-11.02-10.5-11.02l10.5-11.02c.29-.31.46-.72.46-1.18 0-.48-.2-.92-.52-1.24Z"
    })
  });
};